import { render, staticRenderFns } from "./NoteQuestionPoll.vue?vue&type=template&id=7ec4014e&scoped=true"
import script from "./NoteQuestionPoll.vue?vue&type=script&lang=js"
export * from "./NoteQuestionPoll.vue?vue&type=script&lang=js"
import style0 from "./NoteQuestionPoll.vue?vue&type=style&index=0&id=7ec4014e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec4014e",
  null
  
)

export default component.exports